// http://localhost:3000/app/auth?auth_token=ILtFcw%2Bxtbuy8IgsBCSyD6nSpgZd5AOz7T%2Bg3N8Tef%2FINZi%2BdxwPJhnBc2kfdq2eGWGuIH5BRNp43a6OL3SmktpGNSNMnZrR0neJ9UF8fiswn%2BFtwaXasT0icQEmxcQP9LDJV%2BpwJaFLZ0TM%2Bjd0G9tXTnK8hJz1eU3wk3c0ghr4lWnNxbhAXA7LDHY4sexxI9GnS%2FnQfLO%2Fh%2F6BVsFlPgFztC0FcAdHR4TtoHaFO9zIQbBXWcg3JszGsTja8zx%2BDQxl31Yg2UxqglzE5xwGa413HoZUYdllIjsSAoDoOStgPgHudzeb%2FGjmXDhN9iJuy3VpOUfwNTeDtXRCQWePLg9VuYhLB%2BiNbBhLu8uoIFsykUs6yMUai4ZTUh7Q3C36pyEmjJT%2BotwmveGymJm%2FNN2%2B4mjlK2wuzvfM0o53s04Z4DMPV%2BseKF%2FU5jCLVhG3HbzK8uOIcY%2BRhuiXTzZ7bKCRE6ezs3L%2BOy1Amm1drhUIyt%2FxpAf8NbX5Yp91gkA0vD%2FSO%2Fd0zqoezTdiC%2BKuJ2IN1T1dbZ79TWg8baSFqHx4vUDqLWePvIOSz%2BODIU0LqCdn3NvM3tl9Bi1%2BSD%2Bq%2Feyk5Ccz4kXunCwYVv4p%2BvS4nDfChCT%2BaoQANFf6DQbgyHu1KnEtgkryAPttu1UIuDk%2FSvFsvKc0kaKJ3aAmfS0bocNHY9EFGGHFw7BtWtfMU0yIYt7HrZoReVQkh1xwjYKhx7RMBmpWvQV87BR6gO1NbwhL7%2BRxyAcYfB58S0mc7%2FcWBu4kwDQ8%2BxBlDCcIEikVzgxSXkAB5bluDao96aiuBJvFM5rXZucQOu4ik83XyXciogJCp13g3wTn7zgkFTabSYRMX0A2iqDWAIM7oN%2BWvgPtjWOoSgwjmm6znhr8zh4ESjJsSfUmShC7ExCWnnawPK1KGhcK0c5lMEvirba%2FXT9tXTi854b8nQlxPmKiQUHRugqS%2FGWo%2FyJLAjCh07r388pPgcemxv6LceU%2FzzBZgHj771NhD5Ae24uYJhtvzvf8TlBjtbEk%2BhC74TM%2Feg91zsMZouRVdKQkwRU24y0Z%2F2aigSRxFgYtRe%2ByLNPTdOVYRb9u8ijV6O7%2FDik54t9NLlleQuC31ume99Y%2BTmAD2iuBNVJfkIhJG3vWWgORP2Qcnja%2FBOsZFvcGx1rK%2FmV5qQvgDXI1tBIvhjf8LIMyibk2H5RQFG19z8z89cU0ckS%2BbaSuTl7P2DDikkROPjrwnpQ17GUUrS2epZjKX%2F06mq0vqPSBTD6ubAEqvsp9DcaJ%2FY5uacDLlq%2Frrccc9xni%2F00okoOdeYT7j5TJaucOM0Y5pW527wPPW67vFJnwzY9YspGS0U%2BCZSq%2BYlF2KmZF3juz%2FGHqrL21JJFUsByNJ3pWXBj5IPXIjP1vVyJnQZbbT1v1LdT5cS9Z2Zd6iRWVi6J%2BgJkLlrqTyMOyOzUxL%2BlZDjV3hRw%2BiTV%2B3gOeCPv4igtOcYIqC%2Bsg%2BQK98w%2Bsw12DKvV%2FdkEPjfHh0S5GkKo60N%2BFTYhB%2F4uK%2BXCrN3WNhUXPi9cT4iJjhbhISmfkSH7x9U7rp%2BPNel2dQlWeCuxFEX1GcF0X%2BrK8x7VdyAbUnYeTnz18tU6ev4P2Ehqbi2RK5qQUB3aTMJqo%2FOrFi51Aq4Wg5DYwXUlCWrJtK9a6M1GYFMIOa3%2F75ZiCXs0Cwtwls%2Bohel%2FwZnDTofjonp0WXd2Yz2hKMeLOmYHM9ZM541asRjNxzYA8K8BsyyQa05IDaVqq%2BX7OMzaa4S4%3D&app_version=1.0.10&build_version_number=16&platform=android&screen_name=records-screen&screen_params=tab%3Dsymptoms

import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import { getUrlParams } from "src/helpers/common";
import { getPatientDetailsRequest } from "src/redux/slices/authSlice";
import analytics from "src/helpers/analytics";
import { STORAGE_KEYS } from "src/constants/common";
import storage from "src/helpers/storage";
import packageJson from "../../package.json";
import { getRuntimeInfo } from "src/helpers/runtime";
import { monitoring } from "src/monitoring";
import { detectDeviceInfo } from "src/helpers/device";
import supportPrograms from "src/data/app/programs";

export const useAuthGuard = () => {
  const { patient } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  const location = useLocation();

  const queryParams = getUrlParams() as Record<string, string>;
  const urlToken = queryParams?.auth_token;
  const urlAppVersion = queryParams?.app_version || "1.0.0";
  const urlBuildNumber = queryParams?.build_version_number || "1";
  const urlPlatform = queryParams?.platform || "ios";
  const webVersion = packageJson.version;
  const isAuthPage = location.pathname === "/app/auth";

  const [finalToken, setFinalToken] = useState<string | null>(null);
  const [hasResolved, setHasResolved] = useState(false);

  const allowedPrograms = Object.keys(supportPrograms);

  // Set token once on mount
  useEffect(() => {
    if (isAuthPage && urlToken) {
      storage.setItem(STORAGE_KEYS.AUTH_TOKEN, urlToken);
      storage.setItem(STORAGE_KEYS.APP_VERSION, urlAppVersion);
      storage.setItem(STORAGE_KEYS.BUILD_NUMBER, urlBuildNumber);
      storage.setItem(STORAGE_KEYS.PLATFORM, urlPlatform);
      storage.setItem(STORAGE_KEYS.WEB_VERSION, webVersion);
      setFinalToken(urlToken);
    } else {
      const token = storage.getItem(STORAGE_KEYS.AUTH_TOKEN);
      setFinalToken(token);
    }
  }, [isAuthPage, urlToken]);

  // Wait for patient API response
  useEffect(() => {
    if (
      finalToken &&
      !patient?.data &&
      !patient?.error &&
      !patient?.isLoading
    ) {
      analytics.logout();
      new Promise((resolve, reject) => {
        dispatch(getPatientDetailsRequest({ resolve, reject }));
      })
        .then(async (res: any) => {
          setHasResolved(true);
          if (res?.data) {
            const runtime = getRuntimeInfo();
            const deviceInfo = detectDeviceInfo();
            const patient = res.data;

            const userInfo = {
              id: patient.patient_id,
              name: patient.name,
              email: patient.email ? patient.email : "support@goodflip.com",
              mobile_number: patient.contact_no,
              username: patient.contact_no,

              support_program_name:
                patient.patient_meta_info.support_program_type,
              support_program_key:
                patient.patient_meta_info.support_program_key,

              // Runtime Info
              app_version: runtime.app_version,
              app_build_number: runtime.app_build_number,
              web_version: runtime.web_version,
              platform: runtime.platform,

              // Device Info
              device_type: deviceInfo.device_type,
              browser: deviceInfo.browser,
            };

            monitoring.setUser(userInfo);

            analytics.setUserAttributes(patient);
          }
        })
        .catch(() => setHasResolved(true));
    } else if (patient?.data || patient?.error) {
      setHasResolved(true);
    }
  }, [finalToken, patient, dispatch]);

  const programKey = patient?.data?.patient_meta_info?.support_program_key;
  const screenName = queryParams?.screen_name || "home-screen";
  const screenParams = queryParams?.screen_params || "";

  if (!hasResolved) {
    return { status: "loading", redirectTo: null };
  }

  if (!finalToken) {
    return {
      status: "unauthenticated",
      redirectTo: isAuthPage ? "/app/something-went-wrong" : "/app/auth",
    };
  }

  if (!hasResolved || patient?.isLoading) {
    return { status: "loading", redirectTo: null };
  }

  if (patient?.error) {
    return { status: "error", redirectTo: "/app/something-went-wrong" };
  }

  if (!programKey || !allowedPrograms.includes(programKey)) {
    return { status: "invalid-program", redirectTo: "/app/invalid-program" };
  }

  const allowedScreenNames = [
    // landing screens
    "home-screen",
    "records-screen",
    "insights-screen",
    "chat-screen",
    "health-assistant-screen",

    // inner screens
    "book-consultation",
    "book-lab-test",
  ];

  const finalScreenName = allowedScreenNames.includes(screenName)
    ? screenName
    : "home-screen";
  const finalScreenParams = allowedScreenNames.includes(screenName)
    ? screenParams
    : "";

  return {
    status: "success",
    // redirectTo: isAuthPage ? `/app/${programKey}/home-screen` : null,
    redirectTo: isAuthPage
      ? `/app/${programKey}/${finalScreenName}?${finalScreenParams}`
      : null,
  };
};
